import {gsap} from "../../lib/gsap";

export default class BlockTextSlider {
	static init() {

		let blocks = document.querySelectorAll('.block-text-slider');

		blocks.forEach( (block) => {
			const swiper = block.querySelector('.swiper');
			const prev = block.querySelector(".swiper-custom-button-prev");
			const next = block.querySelector(".swiper-custom-button-next");
			let swiperElement = new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: false,
				spaceBetween: 20,
				breakpoints: {
					768: {
						slidesPerView: 1,
						spaceBetween: 20,
						allowTouchMove: false
					}
				},
				navigation: {
					prevEl: prev,
					nextEl: next
				}
			});

			swiperElement.slides.forEach( (slide) => {
				const scrollingText = slide.querySelectorAll(' .text');
				// setTimeout(() => {
				// 	gsap.to(scrollingText, {
				// 		xPercent: -200,
				// 		duration: 20,
				// 		ease: "linear",
				// 		repeat: -1
				// 	});
				// });
			});
		});

	}
}
